import { Component, Watch } from 'vue-property-decorator';

import {
    Item,
    itemSelectors,
    Location as LocationEntity,
    LocationDataStore,
    locationSelectors,
} from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    props: ['item'],
    template: require('./location.html'),
})
export class Location extends ReactiveVue {
    public item: Item;

    public $locationDataStore: LocationDataStore;
    public locationSelectors = locationSelectors;
    public location: LocationEntity = null as any;

    public created() {
        this.subscribe();
    }

    private subscribe() {
        const locationId = itemSelectors.realTimeLocation(this.item);
        if (!locationId) {
            this.$emit('ready');
            return;
        }

        this.subscribeTo(
            this.$locationDataStore.fetchOne(locationId),
            location => {
                this.$emit('ready');
                this.location = location;
            },
            'location',
        );
    }

    @Watch('item')
    private onItemChange() {
        this.unsubscribeFrom('location');
        this.subscribe();
    }
}
